import React from 'react'
import { Link } from "react-router-dom";
import BadgeNew from './BadgeNew/BadgeNew';
import BadgeNotification from './BadgeNotification/BadgeNotification';

interface AsideBarLinkProps {
    id:string;
    activeMenuLinkId:string;
    linkText:string;
    link?:string; //For fast routing inside the funnel
    href?:string; // For external routes like in cms for example
    iconSrc?:string;
    alt? : string;
    show?:boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    notificationsAmount?: number;
    showBadgeNew?: boolean;
    badgeNewText?: string;
    badgeNewColor?: string;
    // Force the icon to render in its "active" (visible-on-desktop) style even
    // when this link isn't the active tab — used by the store WalkMe to reveal
    // the icon while the walkthrough highlights the item.
    forceShowIcon?: boolean;
    itemRef?: React.Ref<HTMLLIElement>;
}


const AsideBarLink: React.FC<AsideBarLinkProps> = ({id,
  iconSrc,
  activeMenuLinkId,
  linkText,
  link,
  href,
  alt,
  show=true,
  onClick,
  notificationsAmount=0,
  showBadgeNew=false,
  badgeNewText,
  badgeNewColor,
  forceShowIcon=false,
  itemRef,
}) => {

  return (
      show ?
      <li ref={itemRef} className={activeMenuLinkId === id ? "asidebar-link-active" : "asidebar-link" } id={id}>
          { iconSrc ?
           <img className={(activeMenuLinkId === id || forceShowIcon) ? "asidebar-link-icon-active" : "asidebar-link-icon" } src={iconSrc} alt={alt} />
            :
           null
          }

          {
            href ? 
            <a id={`${id}-link`} href={href} onClick={onClick}>{linkText}</a> 
            : 
            <Link id={`${id}-link`} onClick={onClick} to={link!}> {linkText} </Link>
          }

          <BadgeNotification amount={notificationsAmount}/>
          <BadgeNew show={showBadgeNew} text={badgeNewText} color={badgeNewColor}/>
      </li>
      :
      null
  )
}

export default AsideBarLink